// Loading spinner component

import { Box, Spinner, Text, VStack } from '@chakra-ui/react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * Centered loading spinner component
 */
export function LoadingSpinner({ message, size = 'xl' }: LoadingSpinnerProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH="400px"
      w="full"
    >
      <VStack spacing={4}>
        <Spinner size={size} color="brand.500" thickness="4px" />
        {message && (
          <Text color="gray.600" fontSize="sm">
            {message}
          </Text>
        )}
      </VStack>
    </Box>
  );
}
